<template>
  <div class="report_cell" :week="week_id">
    <div class="report_title">
      <span class="week_title">{{week_title}}</span>
      <div class="report_cell_time">{{deadline}} 到期</div>
    </div>
    <div class="report_cell_content container-fluid">
      <div class="row">
        <div v-if="activities.length === 0" style="text-align: center; font-size: 16pt; color: darkgray; ">暫無任務</div>
        <ActivityCell v-for="activity in activities" :key="activity.id" :week_id="week_id" :activity="activity" class="col-sm-6 col-lg-4"/>
      </div>
    </div>
  </div>
</template>
<style type='text/css' scoped>
.report_cell {
  width:95%;
  -moz-box-shadow: 0 0 5px #8DD;
  -webkit-box-shadow: 0 0 5px #8DD;
  box-shadow: 0 0 5px #8DD;
  background-color: #fff;
  padding: 10px;
  border-radius: 11px;
  font-size: 15pt;
  font-weight: bold;
  color: rgb(142, 202, 147);
  margin: 12px;
}
.report_cell_time {
  float:right;
  font-size: 12pt;
  font-weight: 400;
}
</style>
<script>
import ActivityCell from '@/components/Report/ActivityCell.vue'
export default {
  props: {
    week_id: Number,
    week_title: String,
    activities: Array,
    deadline: String
  },
  components: {
    ActivityCell
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
